import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { useControlled } from '../../../../internal/hooks';
/**
 * Хук-контроллер, возвращающий подготовленное состояние
 * и обработчики событий для отдельных частей Tooltip-компонент
 *
 * Этот контроллер реализует поведение открытия/закрытия по клику
 *
 * @export
 * @param {IBaseTooltipProps} props
 * @returns
 */
export function useClickController(props) {
  var children = props.children,
    onClose = props.onClose,
    onOpen = props.onOpen;
  var childrenRef = React.useRef(null);
  var handleChildrenRef = useForkRef(children.ref, childrenRef);
  var _useControlled = useControlled({
      controlled: props.open,
      default: false
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    open = _useControlled2[0],
    setOpen = _useControlled2[1];
  var handleClose = React.useCallback(function () {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  }, [onClose, setOpen]);
  var handleClick = function handleClick(e) {
    var childrenProps = children.props;
    if (childrenProps.onClick) {
      childrenProps.onClick(e);
    }
    if (e.defaultPrevented) {
      return;
    }
    e.stopPropagation();
    var nextState = !open;
    setOpen(nextState);
    if (nextState) {
      if (onOpen) {
        onOpen();
      }
    } else {
      if (onClose) {
        onClose();
      }
    }
  };
  var childrenProps = _objectSpread(_objectSpread({}, children.props), {}, {
    onClick: handleClick,
    ref: handleChildrenRef
  });
  return {
    childrenRef: childrenRef,
    childrenProps: childrenProps,
    open: open,
    handleClose: handleClose
  };
}